import type { ReactNode } from 'react';
import { Search } from 'lucide-react';
import './SearchBar.css';

export type SearchBarProps = {
    value: string;
    onChange: (v: string) => void;
    placeholder?: string;
    /** Optional filter chip row rendered beside / below the input */
    filters?: ReactNode;
    ariaLabel?: string;
};

function SearchBar({
    value,
    onChange,
    placeholder = 'Search…',
    filters,
    ariaLabel,
}: SearchBarProps) {
    return (
        <div className="ui-searchbar">
            <div className="ui-searchbar__input-wrap">
                <Search className="ui-searchbar__icon" size={18} />
                <input
                    type="text"
                    className="ui-searchbar__input"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    aria-label={ariaLabel || placeholder}
                />
            </div>
            {filters && <div className="ui-searchbar__filters">{filters}</div>}
        </div>
    );
}

export default SearchBar;
